/**
 *
 * Asynchronously loads the component for ContactUs
 *
 */

import React from 'react'
import loadable from 'utils/loadable'
import { Loading } from 'components/Loading'

export default loadable({
  loader: () => import('./index' /* webpackChunkName: "ContactUs" */),
  loading: <Loading />
})
